import { qualifyUrls } from 'routing/Routes';

const OnePasswordRoutes = {
  INTEGRATIONS: {
    OnePassword: {
      ACTIVITYAPI: {
        index: '/integrations/onepassword',
      },
    },
  },
};

const ApiRoutes = {
  INTEGRATIONS: {
    OnePassword: {
      SAVE_INPUT: '/plugins/org.graylog.enterprise.integrations/onepassword/inputs',
      CHECK_CREDENTIALS: '/plugins/org.graylog.enterprise.integrations/onepassword/check_credentials',
    },
  },
};

const DocsRoutes = {
  INTEGRATIONS: {
    OnePassword: {
      GRAYLOG_OnePassword_ACTIVITY_LOG_INPUT:
        'integrations/inputs/graylog_onePassword_ActivityLog_Input.html#graylog-onepassword-activitylog-input',
    },
  },
};

export default {
  ...qualifyUrls(OnePasswordRoutes),
  unqualified: OnePasswordRoutes,
};

export { DocsRoutes, ApiRoutes };
